import { useMemo } from "react";
import {
    useGetAllClauses,
    useGetPersonClauses,
} from "../../../services/clausesService";
import { t } from "i18next";
import { Grid } from "@mui/material";
import { ControlledSelect } from "../../form/ControlledSelect/ControlledSelect";
import TrueFalseSelectField from "../../field/TrueFalseSelectField/trueFalseSelectField";
import DateService from "../../../services/dateService";
import TextFieldFormControl from "../../field/TextFieldFormControl";
import BaseTable from "../../table/BaseTable";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import ConfirmChangePersonClauseDialog from "./ConfirmChangePersonClauseDialog";

const HEADERS = [
    t("clients.PersonClausesDialog.table.clause_name"),
    t("clients.PersonClausesDialog.table.persclau_decision"),
    t("clients.PersonClausesDialog.table.created"),
];

export const ActualClausesTab = (props) => {
    const { data: allClauses, isLoading: isLoadingAllClauses } = useGetAllClauses(new URLSearchParams({clause_active: true}));
    const { data: personClauses, isLoading: isLoadingPersonClauses } = useGetPersonClauses(props.personId || "", {
        enabled: !!props.personId,
    });

    const mergedClauses = useMemo(()=>{
        if (isLoadingAllClauses || isLoadingPersonClauses) {
            return [];
        }
        
        const mergedClauses = allClauses?.results.map((clause) => ({
            clauseId: clause.id,
            clauseName: clause.clause_name,
            dateChanged: personClauses?.results.find(
                (c) => c.persclau_clause === clause.id,
            )?.created,
            clauseIsTemporary: clause.clause_is_temporary,
            decision:
                personClauses?.results.find((c) => c.persclau_clause === clause.id)
                    ?.persclau_decision,
        }));

        return mergedClauses

    }, [isLoadingAllClauses, isLoadingPersonClauses, personClauses])

    const { closeDialog, openDialog } = useDialogBetter();

    const handleOpenConfirmChangePersonClauseDialog = ({clauseId, clauseName, clauseDecision}) => {
        openDialog({
            Component: ConfirmChangePersonClauseDialog,
            componentProps: {
                personId: props.personId,
                personName: props.personName,
                clauseId: clauseId,
                clauseName: clauseName,
                clauseDecision: clauseDecision
            },
        });
    }

    const rows = useMemo(()=>{
        if (!mergedClauses) {
            return [];
        }

        return mergedClauses.map((clause) => ({
            rowId: clause.clauseId,
            data: [
                clause.clauseName,
                <TrueFalseSelectField
                    readOnly={props.readOnly}
                    name={"decision"}
                    valuesAsBool={true}
                    value={clause.decision}
                    variant="outlined"
                    addEmptyOptions={false}
                    onChange={(e)=>handleOpenConfirmChangePersonClauseDialog({clauseId: clause.clauseId, clauseName: clause.clauseName, clauseDecision: e.target.value, clauseIsTemporary: clause.clauseIsTemporary})}
                    />,
                DateService.convertDatetimeFromBackendToFormatYYYYMMDD_hhmmss(clause.dateChanged),
            ],
        }));
    }, [mergedClauses])


    return (
        <Grid container rowGap={1}>
            <BaseTable
                stickyHeader={false}
                headers={HEADERS}
                rows={rows}
                showEditButton={false}
                showDeleteButton={false}
                sortable={false}
                hiddenColumns={[]}
                selectedRows={[]}
            />
        </Grid>
    )
};
